<template>
  <svg
    width="22"
    height="24"
    viewBox="0 0 22 24"
  >
    <path d="M11 0C6.02945 0 2.00001 4.02944 2.00001 9V13.8028L0.0714061 18.6289C-0.0517074 18.937 -0.014013 19.2861 0.172029 19.5608C0.358072 19.8355 0.668239 20 1 20H7C7 22.2167 8.78329 24 11 24C13.2167 24 15 22.2167 15 20H21C21.3318 20 21.6419 19.8355 21.828 19.5608C22.014 19.2861 22.0517 18.937 21.9286 18.6289L20 13.8028V9C20 4.02944 15.9706 0 11 0ZM13 20C13 21.1121 12.1121 22 11 22C9.88786 22 9 21.1121 9 20H13ZM4.00001 9C4.00001 5.13401 7.13402 2 11 2C14.866 2 18 5.13401 18 9V13.9952C18 14.1223 18.0242 14.2483 18.0714 14.3663L19.5235 18H2.47651L3.92861 14.3663C3.97578 14.2483 4.00001 14.1223 4.00001 13.9952V9Z" />
  </svg>
</template>
